function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#people_svg__clip0_19861_983)",
  stroke: "#1063CD",
  strokeLinecap: "round"
}, React.createElement("path", {
  d: "M.583 11.667v-.584a4.083 4.083 0 0 1 8.167 0v.584"
}), React.createElement("path", {
  d: "M7.583 8.167a2.917 2.917 0 0 1 5.834 0v.291"
}), React.createElement("path", {
  d: "M4.667 7a2.333 2.333 0 1 0 0-4.667 2.333 2.333 0 0 0 0 4.667zM10.5 5.25a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5z",
  strokeLinejoin: "round"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "people_svg__clip0_19861_983"
}, React.createElement("path", {
  fill: "#fff",
  d: "M0 0h14v14H0z"
})));

const SvgPeople = props => React.createElement("svg", _extends({
  width: 14,
  height: 14,
  fill: "none"
}, props), _ref, _ref2);

export default SvgPeople;